import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import styles from './movimientos.module.sass'
import CurrencyFormat from 'react-currency-format'
import { useIsMobile } from 'hooks/useIsMobile'
import { useToken } from 'hooks/useToken'

import { getMovements } from 'services/Movements'

import { dateFormatClaroConAnio } from 'functions/dateFormat'
import { decodeStorage } from 'functions/storageBase64'

import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'

export function useMovements(){

    const { isMobile } = useIsMobile()
    const history = useHistory()

    const cardending = decodeStorage('cardending')

    const [ loading, setLoading ] = useState(true)
    const [ response, setResponse ] = useState()
    const [ respMovements, setRespMovements ] = useState()

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        window.ineum('page', 'Movements Credit-Page')
        window.ineum('meta', 'portal', 'Credito')
    },[]) 

    /*  --------------------------- Inicio --------------------------------------  */
    const timeToken  = useToken({firstActive: false, name: "Movimientos", timeRef: 1000 })
    const [actionOK, setActionOk] = useState(false)
    /*  --------------------------- Inicio Peticiones --------------------------------------  */
        //  Ajusta Los tiempos y refresca token
        const [serviceRT, setServiceRT] = useState(false)
        useEffect(()=>{
            if(actionOK){
                let  actTimeLS = Date.now()
                let  atExpLS = decodeStorage('access_token_exp') * 1000

                // console.log('------------------------------')
                // console.log('actTimeLS   : ', new Date() )
                // console.log('actTimeLS m : ', ( new Date( Date.now() + 180000) ) )
                // console.log('atExp   : ', new Date (atExpLS) )
                // console.log('time ok : ', actTimeLS <= atExpLS)
                // console.log('actionOK: ', actionOK)
                // console.log('------------------------------')
                
                if(actTimeLS <= atExpLS || Date.now() <= (decodeStorage('access_token_exp') * 1000) ){
                    setServiceRT(true)
                }
                else{
                    timeToken.forceToken(true)
                }
            }
        },[timeToken.newToken, actionOK])
    /*  --------------------------- Fin --------------------------------------  */

    useEffect(()=>{
        if(serviceRT){
            if(cardending){
                getMovements({cardending: cardending})
                .then(setResponse)
            }else{
                history.push(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
            }
        }
    },[serviceRT])

    const [errorCode, setErrorCode] = useState();
    const [cargos, setCargos] = useState(0.0);
    const [abonos, setAbonos] = useState(0.0);
    useEffect(()=>{
        if(response){
            if(response?.statusCode === 200){
                setLoading(false);
                if(response?.data){
                    if(response?.data?.movimientos){
                        setRespMovements(response?.data?.movimientos);
                    }
                    setCargos(response?.data?.sumcargo);
                    setAbonos(response?.data?.sumabono);
                }
            }
            else if(response?.statusCode >= 400 && response?.statusCode <= 499){
                let codeError = JSON.parse(response?.data);
                setErrorCode(codeError);
                setLoading(false);
            }
            else if(response?.statusCode >= 500){
                setErrorCode(response?.statusCode);
                setLoading(false);
            }
        }
    },[response])

    const sendMovements = () => {
        setLoading(true)
        setActionOk('ready')
    }

    return{
        sendMovements,
        isMobile,
        respMovements,
        cargos,
        abonos,
        loading,
        errorCode
    }
}


export function NoMovements(){

    return(
        <div className={styles?.noMovements}>
            <img src="/credito-claroshop/img/newCredito/sin_movimiento.svg" className={styles?.noMovementsImage} />
            <h2 className={styles?.h1} >Sin movimientos</h2>
            {/* <p className={styles?.h2}>Aún no haz realizado compras ¡Aprovecha tu crédito para consentirte con lo que más te gusta!</p> */}
            <p className={styles?.h2}>No realizaste movimientos durante este período.</p>
        </div>
    )
}

export function MovementsCards(props){
    const {
        respMovements
    } = props
    return(
        <div className={styles?.listMovements}>
            {
                respMovements?.length >= 1
                    ?
                        <ul>
                            {respMovements && respMovements.map((opcion, ind) =>
                                <li key={ind} className={opcion?.iconos[0]?.icon === 2 ? styles?.abonoStyle : null}>
                                    <div className={styles?.movementImage}>
                                        <img src={opcion?.iconos[0]?.url?.replace('-lazavip', '-plazavip')} alt={`imagen ${opcion?.transaction_description}`} />
                                    </div> 
                                    
                                    <div className={(opcion?.iconos[0]?.icon === 2 || opcion?.iconos[0]?.icon === 3) ? `${styles?.movementData} ${styles?.abono}` : styles?.movementData}>
                                        <p className={styles?.movDate}>
                                            {dateFormatClaroConAnio(opcion?.date_activity)}
                                        </p>
                                        <p className={styles?.movTitle}>
                                            {opcion?.transaction_description}
                                        </p>
                                        {opcion?.mensualidades
                                            ?
                                                <p className={styles?.movTitleMonth}>
                                                    {opcion?.mensualidades >= 2 ? `${opcion?.mensualidades}  mensualidades` :  `${opcion?.mensualidades}  mensualidad`}
                                                </p>
                                            : null
                                        }
                                    </div> 
                                    
                                    <div className={(opcion?.iconos[0]?.icon === 2 || opcion?.iconos[0]?.icon === 3) ? `${styles?.movementImport} ${styles?.abono}` : styles?.movementImport}>    
                                        <CurrencyFormat
                                            value={Number(opcion?.importe % 1) === 0 ? opcion?.importe + '.001' : opcion?.importe}
                                            displayType={'text'}
                                            decimalScale={2}
                                            FixedDecimalScale={true}
                                            thousandSeparator={true} prefix={'$'} renderText={value => <>{value} </>}
                                        />
                                    </div> 
                                </li>
                            )}
                        </ul>
                    : <NoMovements />
            }
        </div>
    )
}

